export class User {
    id: number;
    businessName: string;
    email: string;
    mobile: string;
    addressLine1: string | null;
    addressLine2: string | null;
    country: string | null;
    province: string | null;
    city: string | null;
    postalCode: string | null;
    category: number;
    status: string;

    constructor(
        id: number,
        businessName: string,
        email: string,
        mobile: string,
        addressLine1: string | null,
        addressLine2: string | null,
        country: string | null,
        province: string | null,
        city: string | null,
        postalCode: string | null,
        category: number,
        status: string
    ) {
        this.id = id;
        this.businessName = businessName;
        this.email = email;
        this.mobile = mobile;
        this.addressLine1 = addressLine1;
        this.addressLine2 = addressLine2;
        this.country = country;
        this.province = province;
        this.city = city;
        this.postalCode = postalCode;
        this.category = category;
        this.status = status;
    }
}
